import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { Spinner } from './../../../../core/services/spinner.service';
import { NewsService } from './../../../../shared/service/news.service';

@Component({
  selector: 'app-news-dashboard',
  templateUrl: './news-dashboard.component.html',
  styleUrls: ['./news-dashboard.component.scss']
})
export class NewsDashboardComponent implements OnInit {

  public title: string;
  public author: string;
  public lastUpdated: string;
  public content: any;
  public nextNews: number;
  public previousNews: number;
  public search = '';
  public page = 0;
  public size = 4;
  public listNews = [];
  public searchTimeoutInstance: any;
  public totalPages = 0;
  constructor(
    private spinner: Spinner,
    private newsService: NewsService,
    private activatedRoute: ActivatedRoute,
    private sanitizer: DomSanitizer
  ) {
   }

  ngOnInit() {
    this.getListNews();
    this.activatedRoute.params.subscribe(res => {
      if (res.id) {
        this.getMainNews(res.id);
      } else {
        this.getMainNews();
      }
    });
  }

  getMainNews(id?) {
    if (!id) {
      id = -1;
    }
    this.spinner.show();
    this.newsService.getNewsPublishById(id).subscribe(res => {
      this.spinner.hide();
      if (res.data) {
        this.title = res.data.title;
        this.author = res.data.author;
        this.content = this.sanitizer.bypassSecurityTrustHtml(res.data.content);
        this.lastUpdated = new Date(res.data.lastUpdated).toLocaleDateString();
        this.nextNews = res.data.nextNews;
        this.previousNews = res.data.previousNews;
      }
    });
  }

  getListNews() {
    if (this.searchTimeoutInstance) {
      clearTimeout(this.searchTimeoutInstance);
    }
    this.searchTimeoutInstance = setTimeout(() => {
      this.newsService.getListNews(this.page, this.size, this.search).subscribe((res: any) => {
        if (res.status === 200) {
          this.listNews = res.data.content.map(item => {
            item.lastUpdated = new Date(item.lastUpdated).toLocaleDateString();
            return item;
          });
          this.totalPages = res.data.totalPages;
        }
      });
    }, 1000);
  }

  paging(nber: number) {
    this.page = nber;
    this.getListNews();
  }

  counter(i: number) {
    return new Array(i);
  }

  public redirectTo(id) {
    this.getMainNews(id);
  }

}
